<template>
  <div class="voucher-item" :class="{ 'border-bottom': showBorder }">
    <div class="voucher-header">
      <div class="voucher-info">
        <div class="merchant-logo">
          <img :src="logoUrl" :alt="merchantName" />
        </div>
        <span class="merchant-name">{{ merchantName }}</span>
        <div class="voucher-amount">
          <span class="amount-text">{{ formatter.format(parseFloat(amount)) }}</span>
          <button v-if="showDelete" class="delete-button" @click="$emit('delete')" :title="`Remove ${merchantName} voucher`">
            <v-icon size="12">mdi-close</v-icon>
          </button>
        </div>
      </div>
    </div>
    
    <div class="voucher-details">
      <div class="cashback-info">
        <div class="cashback-badge">
          <span class="cashback-percentage">{{ cashbackPercentage }}%</span>
        </div>
        <div class="cashback-text">
          <span class="cashback-label">Cashback</span>
          <span class="cashback-amount">
            {{ formatter.format(parseFloat(amount) * cashbackPercentage / 100) }}
          </span>
        </div>
      </div>
      
      <div class="item-controls">
        <div class="edit-button" @click="$emit('edit')">
          <span>Edit</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VoucherCartItem',
  props: {
    logoUrl: {
      type: String,
      required: true
    },
    merchantName: {
      type: String,
      required: true
    },
    amount: {
      type: [String, Number],
      required: true
    },
    cashbackPercentage: {
      type: Number,
      required: true
    },
    formatter: {
      type: Object,
      required: true
    },
    showBorder: {
      type: Boolean,
      default: false
    },
    showDelete: {
      type: Boolean,
      default: false
    }
  },
  emits: ['edit', 'delete']
}
</script>

<style scoped>
.voucher-item {
  padding: 12px;
}

.voucher-item.border-bottom {
  border-bottom: 1px solid #f0f0f0;
}

.voucher-header {
  margin-bottom: 8px;
}

.voucher-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.merchant-logo {
  width: 48px;
  height: 32px;
  border-radius: 4px;
  overflow: hidden;
  background: #f5f5f5;
}

.merchant-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.merchant-name {
  font-size: 15px;
  color: var(--text-color);
  flex: 1;
}

.voucher-amount {
  display: flex;
  align-items: center;
  gap: 8px;
}

.amount-text {
  font-size: 15px;
  color: var(--text-color);
}

.delete-button {
  background: #F5F4F6;
  border-radius: 100px;
  border: none;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  color: #000000;
}

.delete-button:hover {
  background: #e8e7ea;
}

.voucher-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cashback-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cashback-badge {
  background: rgba(224, 235, 227, 0.5);
  border-radius: 44px;
  padding: 4px 8px;
}

.cashback-percentage {
  font-weight: bold;
  font-size: 13px;
}

.cashback-text {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.cashback-label {
  font-size: 13px;
  color: var(--text-color);
}

.cashback-amount {
  font-weight: 500;
  font-size: 13px;
  color: var(--text-color);
}

.item-controls {
  display: flex;
  align-items: center;
}

.edit-button {
  background: #F5F4F6;
  border-radius: 100px;
  padding: 0 12px;
  height: 24px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.edit-button:hover {
  background: #e8e7ea;
}

.edit-button span {
  font-weight: 500;
  font-size: 9px;
  color: var(--text-color);
}
</style>